module.exports = __webpack_public_path__ + "img/38.6551a538.png";